/**
 * تشخیص نوع نمایش: PWA یا Web Browser
 */

// تشخیص اینکه آیا اپلیکیشن در حالت PWA (Standalone) اجرا می‌شود یا خیر
export const isPWA = () => {
  // بررسی display mode
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  
  // بررسی navigator.standalone (برای iOS)
  const isIOSStandalone = window.navigator.standalone === true;
  
  // بررسی document.referrer برای شناسایی PWA در اندروید
  const isAndroidPWA = document.referrer.includes('android-app://');
  
  return isStandalone || isIOSStandalone || isAndroidPWA;
};

// درخواست permission نوتیفیکیشن
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('این مرورگر از نوتیفیکیشن پشتیبانی نمی‌کند');
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.error('خطا در درخواست permission نوتیفیکیشن:', error);
    return false;
  }
};

// نمایش نوتیفیکیشن (برای استفاده آینده)
export const showNotification = (title, options = {}) => {
  if (!('Notification' in window)) {
    return;
  }

  if (Notification.permission === 'granted') {
    new Notification(title, {
      icon: '/logo192.png',
      badge: '/logo192.png',
      ...options
    });
  }
};

// بررسی اینکه آیا PWA قابل نصب است یا خیر
export const canInstallPWA = () => {
  return 'BeforeInstallPromptEvent' in window || window.deferredPrompt !== undefined;
};
